/*
- It is working with Safari, iOS, Chrome, Firefox, Edge and another browsers.
- It returns in Uppercase ("ES", "US") for consistency with ISO 3166.
*/
export function getServerLanguage() {
  // Safari e iOS suelen tener navigator.languages[0]
  if (navigator.languages && navigator.languages.length > 0) {
    return navigator.languages[0];
  }

  // Wider Fallbacks
  return (
    navigator.language ||
    navigator.userLanguage ||
    navigator.browserLanguage ||
    navigator.systemLanguage ||
    "en-US"
  );
}

export function getLanguageAndRegion() {
  const locale = getServerLanguage();

  if (!locale || typeof locale !== "string") {
    return { language: "en", region: null };
  }

  // Normalize to standard format, ej. "es_ES" → "es-ES"
  const normalized = locale.replace("_", "-").toLowerCase();

  // Split by language and region
  const [language, regionPart] = normalized.split("-");
  const region = regionPart ? regionPart.toUpperCase() : null;

  return { language, region };
}
